export const ACTIVE_CLIENT_ID_KEY = "activeClientUserId";
export const ACTIVE_CLIENT_NAME_KEY = "activeClientName";

export const getActiveClientId = () => localStorage.getItem(ACTIVE_CLIENT_ID_KEY) || "";

export const setActiveClient = (client) => {
  if (!client?.id) return;
  localStorage.setItem(ACTIVE_CLIENT_ID_KEY, client.id);
  localStorage.setItem(ACTIVE_CLIENT_NAME_KEY, client.name || "");
};

export const clearActiveClient = () => {
  localStorage.removeItem(ACTIVE_CLIENT_ID_KEY);
  localStorage.removeItem(ACTIVE_CLIENT_NAME_KEY);
};
